import { createFileRoute } from '@tanstack/react-router';
import { useUser } from '@hooks/useUser.ts';

export const Route = createFileRoute('/auth')({
  component: AuthDebugPage,
});

function AuthDebugPage() {
  const { beUser } = useUser();

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Auth Debug</h1>
      <pre className="bg-gray-100 border border-gray-300 rounded p-4 text-sm overflow-auto whitespace-pre-wrap">
        {JSON.stringify(beUser, null, 2)}
      </pre>
    </div>
  );
}
